// extracted by mini-css-extract-plugin
export default {"car_wrapper":"ChatCard_car_wrapper__WnTOR","text":"ChatCard_text__fTmIy","user_wrapper":"ChatCard_user_wrapper__sBhh2","shimmer":"ChatCard_shimmer__OGA06"};